<template>
    <span class="text-5xl xl:text-6xl xxl:text-7xl text-primary font-bold" v-text="displayNumber + '+'"></span>
</template>
<script>
export default {
    props: [
        'number',
        'allowCounting'
    ],

    data() {
        return {
            displayNumber: 0,
            interval: false,
        }
    },

    watch: {
        number: function () {
            clearInterval(this.interval)
            if (this.number == this.displayNumber) { return; }

            this.interval = window.setInterval(function () {
                if (this.displayNumber != this.number) {
                    let change = (this.number - this.displayNumber) / 10
                    change = change >= 0 ? Math.ceil(change) : Math.floor(change)

                    this.displayNumber = this.displayNumber + change
                }
            }.bind(this), 20)
        },

        allowCounting: function(){
            this.displayNumber =  0;
        }
    }
}
</script>
